import { publicCreatePaymentIntent } from "@babackapp/private-api-client/client/use-public-create-payment-intent";
import { useMutation } from "@tanstack/react-query";
import type { ReturnDraft } from "../types";

type CreatePaymentIntentInput = {
  draft: ReturnDraft;
  checkoutToken: string;
};

export function useCreatePaymentIntent() {
  return useMutation({
    mutationFn: ({ draft, checkoutToken }: CreatePaymentIntentInput) =>
      publicCreatePaymentIntent({
        shopId: draft.shopId,
        orderId: draft.orderId,
        checkoutToken,
        rateHandle: draft.shippingRateId ?? undefined,
        itemsToReturn: draft.lineItems
          .filter((li) => li.resolution === "exchange" && li.exchangeVariantId)
          .map((li) => ({
            lineItemId: li.lineItemId,
            quantity: li.quantity,
            resolution: li.resolution as string,
            variantId: li.exchangeVariantId as string,
          })),
        rebuyItems: null,
      }),
  });
}
